export const DRS_STATUS = [
  { label: "PENDING", value: "PENDING", key: "PENDING" },
  { label: "RESOLVED", value: "RESOLVED", key: "RESOLVED" },
  { label: "PICKED", value: "PICKED", key: "PICKED" },
  { label: "REOPENED", value: "REOPENED", key: "REOPENED" },
  { label: "SKIPPED", value: "SKIPPED", key: "SKIPPED" },
  { label: "REJECTED", value: "REJECTED", key: "REJECTED" },
];
export const DRS_STATUS_COLORS: { [key: string]: string } = {
  PENDING: "orange",
  REOPENED: "purple",
  PICKED: "green",
  RESOLVED: "blue",
  CLOSED: "gray",
  REJECTED: "red",
  SKIPPED: "red",
};
export const DRS_DATES = [
  {
    value: "Today",
    key: "Today",
    label: "Today",
  },
  {
    value: "Last 7 days",
    key: "Last 7 days",
    label: "Last 7 days",
  },
  {
    value: "Last 15 days",
    key: "Last 15 days",
    label: "Last 15 days",
  },
  {
    value: "Last 30 days",
    key: "Last 30 days",
    label: "Last 30 days",
  },
];
export const getDateRange = (filterValue: string) => {
  const today = new Date();
  const tomorrow = new Date();
  tomorrow.setDate(today.getDate() + 1);

  const format = (date: Date) => date.toISOString().slice(0, 10);

  switch (filterValue) {
    case "Today": {
      return {
        startDate: format(today),
        endDate: format(tomorrow),
      };
    }

    case "Last 7 days": {
      const from = new Date();
      from.setDate(today.getDate() - 6); // FIXED
      return {
        startDate: format(from),
        endDate: format(tomorrow),
      };
    }

    case "Last 15 days": {
      const from = new Date();
      from.setDate(today.getDate() - 14); // FIXED
      return {
        startDate: format(from),
        endDate: format(tomorrow),
      };
    }

    case "Last 30 days": {
      const from = new Date();
      from.setDate(today.getDate() - 29); // FIXED
      return {
        startDate: format(from),
        endDate: format(tomorrow),
      };
    }

    default:
      return null;
  }
};

export const DSR_EMITTER_EVENT = "drs-emitter";
export const DRS_NEW_QUESTION = "drs-emitter-new";
export const DRS_CLEAR_FILES = "drs-emitter-clear-files";
export const DRS_DASHBOARD_PAGES = {
  STATE: "state",
  REGIONS: "regions",
  BRANCHES: "branched",
  FACULTIES: "faculties",
};

export const SKIP_DIFFICULTY_LIST = [
  { label: "Easy", value: "EASY" },
  { label: "Medium", value: "MEDIUM" },
  { label: "Hard", value: "HARD" },
  { label: "Very Hard", value: "VERY_HARD" },
];

export const SKIP_REASONS_LIST = [
  { label: "Irrelevant Question", value: "IRRELEVANT_QUESTION" },
  {
    label: "Exceptionally difficult",
    value: "EXCEPTIONALLY_DIFFICULT",
  },
  { label: "Not in the NEET/JEE syllabus", value: "NOT_IN_NEET_JEE_SYLLABUS" },
];
